module.exports = __webpack_public_path__ + "img/c-j_bg.385c4868.png";